__turbopack_context__.v({
  "brand": "boot-splash-module__F6xwIa__brand",
  "caption": "boot-splash-module__F6xwIa__caption",
  "detail": "boot-splash-module__F6xwIa__detail",
  "error": "boot-splash-module__F6xwIa__error",
  "hero": "boot-splash-module__F6xwIa__hero",
  "poster": "boot-splash-module__F6xwIa__poster",
  "screen": "boot-splash-module__F6xwIa__screen",
  "status": "boot-splash-module__F6xwIa__status",
  "track": "boot-splash-module__F6xwIa__track",
  "travel": "boot-splash-module__F6xwIa__travel",
});
